import React from "react";
import Modal from "react-responsive-modal";
import NumberFormat from "react-number-format";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";

// Modal de kilos húmedos, compartido por el reporte de una semana pendiente y
// por la corrección de una semana ya reportada. Solo el reporte muestra las
// semanas que quedarán en 0
export const ModalKgMiga = (props) => {
    const {
        abierto,
        onCerrar,
        titulo,
        descripcion,
        kgHumedos,
        setKgHumedos,
        semanasEnCero,
        onConfirmar,
        textoConfirmar,
        cargando,
    } = props;

    const semanas = semanasEnCero || [];

    return (
        <Modal
            open={abierto}
            onClose={onCerrar}
            closeOnOverlayClick={false}
            focusTrapped={false}
            // style del modal
            // styles={{ modal: { minWidth: "75vw" } }}
            styles={{ modal: { maxWidth: "fit-content" } }}
        >
            <LoadMask loading={cargando} blur>
                <div className="miga-desecho__modal">
                    <h4 className="text-center mb-2">{titulo}</h4>

                    {descripcion && (
                        <p className="text-center text-muted mb-4">
                            {descripcion}
                        </p>
                    )}

                    <div
                        className="formulario-fields-row mt-3"
                        style={{ justifyContent: "center" }}
                    >
                        <div
                            className="formulario-field"
                            style={{ maxWidth: "200px" }}
                        >
                            <label className="text-nowrap">Kilos húmedos</label>
                            <NumberFormat
                                className="form-control"
                                value={kgHumedos}
                                suffix=" Kg"
                                thousandSeparator=","
                                onValueChange={(values) =>
                                    setKgHumedos(
                                        values.floatValue === undefined
                                            ? ""
                                            : values.floatValue,
                                    )
                                }
                                decimalScale={3}
                            />
                        </div>
                    </div>

                    <span className="d-block text-center text-muted mb-3 help-text">
                        Si no hubo miga en esta semana, ingrese 0. Un reporte en
                        0 no requiere análisis de DRC.
                    </span>

                    {semanas.length > 0 && (
                        <div className="alert alert-warning bold white-text">
                            <strong>
                                Al reportar esta semana, las siguientes quedarán
                                reportadas en 0:
                            </strong>

                            <ul className="mb-0 mt-2">
                                {semanas.map((semana) => (
                                    <li key={`${semana.anio}-${semana.semana}`}>
                                        {`${semana.etiqueta} del ${semana.anio} (${semana.rango})`}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <div
                        className="d-flex justify-content-center mt-4"
                        style={{ gap: "1rem" }}
                    >
                        <button
                            type="button"
                            className="btn btn-outline-dark"
                            onClick={onCerrar}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={onConfirmar}
                        >
                            {textoConfirmar}
                        </button>
                    </div>
                </div>
            </LoadMask>
        </Modal>
    );
};
